import { Disclosure } from "@headlessui/react";
import { ChevronDoubleDownIcon } from "@heroicons/react/24/solid";
import React from "react";
import InvoiceItemizedView from "../../InvoiceCapture/view/InvoiceItemizedView";
import useGetItemizedByInvoiceDetailsId from "../hooks/useGetItemizedByInvoiceDetailsId";

interface IProps {
  data;
}

const ItemizedDetailsView: React.FC<IProps> = ({ data }) => {
  const args = data?.invoiceDetailsId ?? 0;
  const { data: itemizedData, isFetching: isLoading } =
    useGetItemizedByInvoiceDetailsId(args);

  return (
    <>
      {/* Allocation Section */}
      <div className={"w-full bg-white p-2 overflow-x-auto shadow-md rounded"}>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <>
              <div className="m-2 bg-white rounded-lg box-shadow">
                <div className="flex flex-row items-center justify-between">
                  <div className="text-base text-quinary font-bold font-sans py-2 px-3">
                    Allocation Section
                  </div>
                  <div>
                    <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                      <ChevronDoubleDownIcon
                        className={`${
                          open ? "transform rotate-180" : ""
                        }  text-gray-500 w-5 h-5 mr-4`}
                      />
                    </Disclosure.Button>
                  </div>
                </div>
                <Disclosure.Panel className="text-xxs">
                  <InvoiceItemizedView
                    rowData={itemizedData}
                    isLoading={isLoading}
                  />
                </Disclosure.Panel>
              </div>
            </>
          )}
        </Disclosure>
      </div>
    </>
  );
};

export default ItemizedDetailsView;
